/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LocationDto } from './LocationDto';
import type { PlannedDateTimeRangeDto } from './PlannedDateTimeRangeDto';
export type TransportationActivityDto = {
    id: string;
    destinationId?: string;
    destination?: LocationDto;
    equipmentId?: string;
    status: TransportationActivityDto.status;
    type: TransportationActivityDto.type;
    comboType: TransportationActivityDto.comboType;
    startPlannedDateTimeRange?: PlannedDateTimeRangeDto;
    startActualDate?: string;
    completionActualDate?: string;
    number: number;
    stage: TransportationActivityDto.stage;
};
export namespace TransportationActivityDto {
    export enum status {
        NEW = 'NEW',
        DRIVER_PLANNED = 'DRIVER_PLANNED',
        DRIVER_REFUSED = 'DRIVER_REFUSED',
        DRIVER_ASSIGNED = 'DRIVER_ASSIGNED',
        DRIVER_CONFIRMED = 'DRIVER_CONFIRMED',
        IN_PROCESS = 'IN_PROCESS',
        COMPLETED = 'COMPLETED',
        UNSUCCESSFUL = 'UNSUCCESSFUL',
    }
    export enum type {
        GOTO = 'GOTO',
        BOBTAIL_GOTO = 'BOBTAIL_GOTO',
        EMPTY = 'EMPTY',
        OFF_DUTY = 'OFF_DUTY',
        PICK_UP_EMPTY = 'PICK_UP_EMPTY',
        PICK_UP_FULL = 'PICK_UP_FULL',
        GET_UNLOADED = 'GET_UNLOADED',
        GET_LOADED = 'GET_LOADED',
        DROP_EMPTY_WITH_CHASSIS = 'DROP_EMPTY_WITH_CHASSIS',
        DROP_FULL_WITH_CHASSIS = 'DROP_FULL_WITH_CHASSIS',
        PICK_CHASSIS = 'PICK_CHASSIS',
        DROP_CHASSIS = 'DROP_CHASSIS',
        DROP_EMPTY_WITH_OUT_CHASSIS = 'DROP_EMPTY_WITH_OUT_CHASSIS',
        DROP_FULL_WITH_OUT_CHASSIS = 'DROP_FULL_WITH_OUT_CHASSIS',
        SCALE_TARE = 'SCALE_TARE',
        SCALE_FULL = 'SCALE_FULL',
    }
    export enum comboType {
        GOTO = 'GOTO',
        BOBTAIL_GOTO = 'BOBTAIL_GOTO',
        EMPTY = 'EMPTY',
        OFF_DUTY = 'OFF_DUTY',
        PICK_UP_EMPTY = 'PICK_UP_EMPTY',
        PICK_UP_FULL = 'PICK_UP_FULL',
        GET_UNLOADED = 'GET_UNLOADED',
        GET_LOADED = 'GET_LOADED',
        DROP_EMPTY_WITH_CHASSIS = 'DROP_EMPTY_WITH_CHASSIS',
        DROP_FULL_WITH_CHASSIS = 'DROP_FULL_WITH_CHASSIS',
        PICK_CHASSIS = 'PICK_CHASSIS',
        DROP_CHASSIS = 'DROP_CHASSIS',
        DROP_EMPTY_WITH_OUT_CHASSIS = 'DROP_EMPTY_WITH_OUT_CHASSIS',
        DROP_FULL_WITH_OUT_CHASSIS = 'DROP_FULL_WITH_OUT_CHASSIS',
        SCALE_TARE = 'SCALE_TARE',
        SCALE_FULL = 'SCALE_FULL',
    }
    export enum stage {
        PICKUP = 'Pickup',
        DELIVERY = 'Delivery',
        RETURN = 'Return',
    }
}

